import styles from './quantity-bar.module.css'

export type QuantityBarProps = {
	max: number | string,
	threshold: number | string,
	total: number,
}

export function convertToInt( value: number | string | null ): number {
	if ( typeof value === 'number' ) {
		return value
	}
	if ( value === '' || value === null ) {
		return 0
	}
	return parseInt( value, 10 )
}

export default function QuantityBar( { max, threshold, total }: QuantityBarProps ) {
	const maxInt = convertToInt( max )
	const thresholdInt = convertToInt( threshold )

	const calculatedMax = Math.max( total, thresholdInt, maxInt ) || 1
	const width = ( total / calculatedMax ) * 100
	const left = ( thresholdInt / calculatedMax ) * 100
	const fgbelowMin = total < thresholdInt ? styles.barFgbelowMin : ''
	const bgbelowMin = total < thresholdInt ? styles.barBgbelowMin : ''

	return (
		<div className={styles.barWrapper}>
			<div
				className={`${styles.bar} ${styles.barFg} ${fgbelowMin}`}
				style={{ width: `${width}%` }}
			/>
			<div className={`${styles.bar} ${styles.barBg} ${bgbelowMin}`} />
			<div
				className={styles.thresholdBar}
				style={{ marginLeft: `${left}%` }}
			/>
		</div>
	)
}
